export default __webpack_public_path__ + "static/media/new-publish-icon.ecfc9cf0.svg";